<script setup lang="ts">
import Tooltip from "~/components/Common/Tooltip.vue";
import { useFormats } from "~/composables/utils/useFormat";
import Card from "~/components/Common/Cards/Card.vue";

const props = defineProps({
  store: {
    type: Object,
    required: false,
  },
});

const formats = useFormats();
</script>

<template #kpi>
  <div v-if="!props.store?.showHideKpi" class="flex gap-4 justify-start px-4 py-4 text-secondary-color">
    <Card shadow radius="12px" class="!px-3 !py-2 !w-fit">
      <template #body>
        <div class="flex items-center justify-between">
          <div v-if="props.store?.trainingPlanKpi">
            <span class="meta_med mr-2">{{ props.store?.trainingPlanKpi.nbParticipants ?? 0 }} </span>
            <span class="meta">{{
              props.store?.trainingPlanKpi.nbParticipants <= 1 ? "Participant" : "Participants"
            }}</span>
          </div>
          <Tooltip :position="'top-right'" class="ml-1">
            <template #content>
              <div class="flex w-[200px] gap-[8px]">
                <img src="/icons/emojis/eyes.svg" alt="" :style="{ height: '16px', width: '16px' }" />
                <span class="meta_med">Nombre total de participants</span>
              </div>
            </template>
          </Tooltip>
        </div>
      </template>
    </Card>
    <Card shadow radius="12px" class="!px-3 !py-2 !w-fit">
      <template #body>
        <div class="flex items-center m-auto">
          <div v-if="props.store?.trainingPlanKpi" class="meta_med">
            <span class="meta_med mr-2"
              >{{
                Number.isFinite(props.store?.trainingPlanKpi?.hoursDone)
                  ? formats.toLocalNumber(props.store?.trainingPlanKpi.hoursDone)
                  : 0
              }}
              / {{ formats.toLocalNumber(props.store?.trainingPlanKpi?.totalDuration ?? 0) }}</span
            >
            <span class="meta">{{
              Number.isFinite(props.store?.trainingPlanKpi?.totalDuration)
                ? "heures réalisées vs total prévu"
                : "heure réalisée vs total prévu"
            }}</span>
          </div>
        </div>
      </template>
    </Card>
    <Card shadow radius="12px" class="!px-3 !py-2 !w-fit">
      <template #body>
        <div class="flex items-center m-auto">
          <div v-if="props.store?.trainingPlanKpi">
            <span class="meta_med mr-2">{{ formats.toCurrency(props.store?.trainingPlanKpi.prices) }}</span>
            <span class="meta">Prix (HT)</span>
          </div>
          <Tooltip :position="'top-right'" class="ml-1">
            <template #content>
              <div class="flex w-[254px] gap-[8px]">
                <img src="/icons/emojis/eyes.svg" alt="" :style="{ height: '16px', width: '16px' }" />
                <span class="meta_med">Cumul des coûts de formation</span>
              </div>
            </template>
          </Tooltip>
        </div>
      </template>
    </Card>
  </div>
</template>

<style lang="scss">
.grid__headers {
  background: var(--grey-light);
  border-color: var(--grey-light);
}

.grid__sort_icon {
  @apply cursor-pointer h-[16px] w-[16px];
}

.kpi {
  color: var(--text-tertiary-color);
}
</style>
